import { bl_fi_budget_generic_doc_line_RowClass } from "../../../dbschema";
import { BaseContainerModel } from "../../base-container.model";

export class BudgetGenericDocLineContainerModel extends BaseContainerModel {
  bl_fi_budget_generic_doc_line: bl_fi_budget_generic_doc_line_RowClass =
    new bl_fi_budget_generic_doc_line_RowClass();
}
